'use strict';
/**
 * MagicZoom is only initialised after the PDP main image has been loaded by lazysizes.
 * This has been done for performance improvement
 */
function initMagicZoomForPDP() {
// For images loaded via lazyloading
    document.addEventListener('lazyloaded', function (e) {
        var imgLoaded = $(e.target);
        // Setting a slight time delay as sometimes there are issues with MagicZoom not getting intialised
        setTimeout(function () {
            if (imgLoaded.hasClass('pdp-main-image')) {
                MagicZoom.start(); //eslint-disable-line
            }
        }, 1000);
    });
    
    var $magicZoom = $('.primary-images .MagicZoom[id^="mz-"]');
    if ($magicZoom.length === 0) {
        $('.pdp-main-image').each(function () {
            var $img = $(this); // store reference to current image
            // Setting a slight time delay as sometimes there are issues with MagicZoom not getting intialised
            setTimeout(function () {
                if ($img.hasClass('lazyloaded')) {
                    MagicZoom.start(); //eslint-disable-line
                }
            }, 1000);
        });
    }
}

function removeDesktopZoomOnMobile() {
    if (window.innerWidth < 1024) {
        var desktopZoomDivs = document.querySelectorAll('[id^="pdp-desktop-custom-zoom"]');
        desktopZoomDivs.forEach(function (div) {
            div.remove();
        });
    }
}
window.addEventListener('load', removeDesktopZoomOnMobile);
window.addEventListener('load', initMagicZoomForPDP);